<template>
 <div class="v-carousel-item">
  <p class="testimonial">{{item_data.testimonial}}</p>
  <div class="person">
   <img 
    :src="item_data.img"
    >
    <div class="person-name-post">
     <p class="name">{{item_data.name}}</p>
     <p class="post">{{item_data.post}}</p>
    </div>
  </div>
  
 </div>
</template>

<script>
export default { 
 props: {
  item_data:{
   type: Object,
   default: ()=> []  
  }
 },
 data() {
   return{

   }
 }
}
</script>

<style lang="sass" scoped>
.v-carousel-item
 width: 800px 
 margin: 0 auto
 
 .testimonial
  width: 800px
  height: 80px
  margin-bottom: 20px
 .person
  width: 800px
  display: flex
  justify-content: flex-start
  img
   width: 100px
   height: 100px
   border-radius: 10px
   margin-right: 15px
   // box-shadow: 0px 0px 7px 3px #000
  .person-name-post
   display: flex
   flex-direction: column
   justify-content: flex-end
   .name
    font-size: 1.5em
    font-weight: 700
    margin-bottom: 10px

@media screen and (max-width: 700px)
  .v-carousel-item
    width: 500px
    // padding: 30px 80px
    .testimonial
      width: 500px
    .person
      width: 500px

@media screen and (max-width: 630px)
  .v-carousel-item
    width: 300px
    // padding: 30px 80px
    .testimonial
      width: 300px
      height: auto
    .person
      width: 300px
  
   
</style>